import type {
    IsoAndUnixTimestamp} from "@@/shared/date-time/iso-and-unix";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import type { Except } from "type-fest";
import { z } from "zod";
import type {
    FeeSourceOrdersFilterId} from "./fee-source-orders-filter-id";
import {
    feeSourceOrdersFilterIdFactory,
    feeSourceOrdersFilterIdZodSchema,
} from "./fee-source-orders-filter-id";

type FeeSourceOrdersFilterDestination = {
    readonly _id: FeeSourceOrdersFilterId;
    readonly _type: "FEE_SOURCE_ORDERS_FILTER";
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly type: "DESTINATION";
    readonly destination: string;
    readonly invert?: boolean;
};

type Params = Except<
    FeeSourceOrdersFilterDestination,
    "_id" | "type" | "_type" | "_createdAt"
>;
const feeSourceOrdersFilterDestinationFactory = (
    params: Params,
): FeeSourceOrdersFilterDestination => {
    return {
        ...params,
        _id: feeSourceOrdersFilterIdFactory(),
        _type: "FEE_SOURCE_ORDERS_FILTER",
        _createdAt: nowIsoAndUnix(),
        type: "DESTINATION",
    };
};

const feeSourceOrdersFilterDestinationZodSchema: z.ZodSchema<FeeSourceOrdersFilterDestination> =
    z.object({
        _id: feeSourceOrdersFilterIdZodSchema,
        _type: z.literal("FEE_SOURCE_ORDERS_FILTER"),
        _createdAt: isoAndUnixZodSchema,
        type: z.literal("DESTINATION"),
        destination: z.string(), // todo: can we make this a kind of async check and have an endpoint that validates the destination name/slug?
        invert: z.boolean().optional(),
    });

export {
    feeSourceOrdersFilterDestinationFactory,
    feeSourceOrdersFilterDestinationZodSchema,
};
export type { FeeSourceOrdersFilterDestination };
